import { X } from "lucide-react";
import { Button } from "./button";
import { InputGroup, InputGroupAddon, InputGroupInput } from "./input-group";

export function InputTextWithClear({
  value,
  onChange,
  onClear,
  placeholder,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder: string;
  className?: string;
}) {
  return (
    <InputGroup>
      <InputGroupInput
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={className}
      />
      <InputGroupAddon align="inline-end">
        <Button variant="ghost" size="icon-xs" onClick={onClear}>
          <X />
        </Button>
      </InputGroupAddon>
    </InputGroup>
  );
}
